/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateClaimImageRequest } from './CreateClaimImageRequest';
export type CreateInvoiceRequest = {
    paidAt: string;
    amount: number;
    paymentType: CreateInvoiceRequest.paymentType;
    paymentMethod: CreateInvoiceRequest.paymentMethod;
    slipImages: Array<CreateClaimImageRequest>;
    remark?: string;
    paymentChannelId?: string;
};
export namespace CreateInvoiceRequest {
    export enum paymentType {
        NONE = 'NONE',
        DEPOSIT = 'DEPOSIT',
        DEPOSIT_REFUND = 'DEPOSIT_REFUND',
        INSTALLMENT = 'INSTALLMENT',
        FULL_PAYMENT = 'FULL_PAYMENT',
        COMPENSATION = 'COMPENSATION',
        REFUND_COMPENSATION = 'REFUND_COMPENSATION',
        HIRE = 'HIRE',
    }
    export enum paymentMethod {
        NONE = 'NONE',
        CASH = 'CASH',
        PROMPT_PAY = 'PROMPT_PAY',
        BANK_TRANSFER = 'BANK_TRANSFER',
    }
}

